// src/components/NewsPage.tsx
import React, { useState } from 'react';
import styles from '../styles/News.module.css';

const News: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const featuredNews = [
    {
      id: 1,
      tag: 'Symposium',
      date: 'October 15, 2024',
      title: 'Annual Philosophy Symposium Focuses on Ethics in AI',
      description:
        'The Department of Philosophy hosted its annual symposium, drawing scholars from across the globe to discuss the ethical implications of artificial intelligence.',
      author: 'Department News',
      image: '../resources/img1.jpg',
    },
    {
      id: 2,
      tag: 'Research',
      date: 'September 30, 2024',
      title: 'New Research Paper Explores Externalization in Contemporary Society',
      description:
        "Professor Deliver's groundbreaking research examines how modern societies externalize responsibility and its philosophical implications.",
      author: 'Research Team',
      image:
        'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
    },
    {
      id: 3,
      tag: 'Achievement',
      date: 'August 01, 2024',
      title: 'Philosophy Graduate Wins National Essay Competition',
      description:
        'Christopher Adams, an outstanding graduate of our Department, has been awarded first place in the prestigious National Essay Competition.',
      author: 'Student Affairs',
      image:
        'https://images.unsplash.com/photo-1543269865-cbf427effbad?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
    },
  ];

  const latestNews = [
    {
      id: 1,
      date: 'October 25, 2024',
      title: 'Annual Philosophy Symposium Focuses on Ethics in AI',
      author: 'Dr. Arjun D. Miller',
      description:
        'The Department of Philosophy hosted its annual symposium, drawing scholars from across the globe to discuss the ethical implications of artificial intelligence.',
      image:
        'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
    },
    {
      id: 2,
      date: 'July 10, 2024',
      title: 'Distinguished Lecturer Series Welcomes Dr. Arjun Sharma',
      author: 'Kenneth Crompton',
      description:
        'Dr. Arjun Sharma delivered a compelling lecture on the philosophy of ethics, discussing contemporary moral dilemmas in our digital age.',
      image:
        'https://images.unsplash.com/photo-1582573618380-9de0c4d3f4d2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
    },
    {
      id: 3,
      date: 'May 8, 2024',
      title: 'Philosophy Outreach Program Engages Local High Schools',
      author: 'Crompton Engagement',
      description:
        "Our department's initiative introduces philosophical concepts to secondary school students, fostering critical thinking skills.",
      image:
        'https://images.unsplash.com/photo-1543269865-cbf427effbad?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
    },
    {
      id: 4,
      date: 'April 10, 2024',
      title: 'New Course Announcement: Philosophy of Science and Technology',
      author: 'Academic Affairs',
      description:
        'Beginning next semester, students are invited to enroll in this cutting-edge course exploring the philosophical dimensions of scientific progress.',
      image:
        'https://images.unsplash.com/photo-1581094794329-16b125e1d71e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
    },
    {
      id: 5,
      date: 'March 18, 2024',
      title: 'Faculty Spotlight: Dr. Chief Nwanch on Logic and Debate',
      author: 'Michael Touw',
      description:
        "Discover Dr. Nwanch's journey and his passionate approach to teaching logical reasoning and debate techniques.",
      image:
        'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
    },
    {
      id: 6,
      date: 'January 03, 2024',
      title: 'Alumni Profile: From Philosophy to Public Policy',
      author: 'Alumni Institution',
      description:
        'Mr. Nwanch: Dr. Nwanch Guides, an alumni who successfully transitioned her philosophical training into impactful public policy work.',
      image:
        'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
    },
  ];

  return (
    <div className={styles['news-page']}>
      {/* Header */}
      <header className={styles['news-header']}>
        <div className={styles['header-overlay']}>
          <div className={styles['header-content']}>
            <h1 className={styles['news-title']}>
              University of Calabar Philosophy Department: Shaping Thought, Inspiring Action
            </h1>
            <div className={styles['search-container']}>
              <input
                type="text"
                placeholder="Search news, events, faculty..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className={styles['search-input']}
              />
              <button className={styles['search-button']}>
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className={styles['news-container']}>
        {/* Featured Stories */}
        <section className={styles['featured-stories']}>
          <h2 className={styles['section-title']}>Featured Stories</h2>
          <div className={styles['stories-grid']}>
            {featuredNews.map((item) => (
              <div className={styles['story-card']} key={item.id}>
                <div
                  className={styles['story-image']}
                  style={{ backgroundImage: `url(${item.image})` }}
                />
                <div className={styles['story-content']}>
                  <div className={styles['story-tag']}>{item.tag}</div>
                  <div className={styles['story-date']}>{item.date}</div>
                  <h3 className={styles['story-title']}>{item.title}</h3>
                  <p className={styles['story-desc']}>{item.description}</p>
                  <a href="#" className={styles['read-more']}>
                    Read More →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Latest News */}
        <section className={styles['latest-news']}>
          <div className={styles['section-header']}>
            <h2 className={styles['section-title']}>Latest News</h2>
            <div className={styles.divider} />
          </div>
          <div className={styles['news-grid']}>
            {latestNews.map((item) => (
              <div className={styles['news-card']} key={item.id}>
                <div
                  className={styles['news-image']}
                  style={{ backgroundImage: `url(${item.image})` }}
                />
                <div className={styles['news-content']}>
                  <div className={styles['news-date']}>{item.date}</div>
                  <h3 className={styles['news-heading']}>{item.title}</h3>
                  <p className={styles['news-author']}>by {item.author}</p>
                  <p className={styles['news-desc']}>{item.description}</p>
                  <a href="#" className={styles['read-more']}>
                    Read More →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default News;
